// Svelte
import { format } from 'svelte-i18n';
// Services
import { localReq, postReq } from '../services/http';
// Design System components
import { toast } from '@Shelly/shelly-design-system';
// Stores
import { get } from 'svelte/store';
import { devices } from 'src/stores/lists/devices';
import { associating_devices } from 'src/stores/device-runtime/cloud-associating';
// Helpers
import { get_local_ip, is_gen_2 } from '../helpers/interface_helpers';
import type { GetSettings } from '../types/requests/settings/GetSettings';
import type { CloudApiResponse } from 'src/types/responses/CloudApiResponse';

const $format = get(format);

export const handleDeviceAssoc = async (deviceId: string) => {
	const owned_res = await postReq('/device/is_available', { id: deviceId });
	const device = get(devices)[deviceId];
	const local_ip = get_local_ip(deviceId);
	const assoc_list = {};

	if (!local_ip) {
		toast.open({
			type: 'danger',
			title: $format('failed_to_add', {
				default: 'Failed to add the device, please try again.',
			}),
		});
		return;
	}

	// this will put the device into cloud associating state
	associating_devices.update(deviceId);

	// ensure device is not associated already
	if (owned_res?.errors?.device_exists) {
		toast.open({
			type: 'danger',
			title: $format('cloud_err_on_connection_toast', {
				values: { cloud_res: owned_res?.errors?.device_exists },
				default: `Could not add device because: ${owned_res?.errors?.device_exists}`,
			}),
		});

		associating_devices.remove(deviceId);
		return;
	}

	// enable device cloud
	let cloud_res;
	if (is_gen_2(device)) {
		cloud_res = await localReq(device, local_ip + '/rpc/cloud.setconfig', 'post', {
			config: { enable: true },
		});
	} else {
		cloud_res = await localReq(
			device,
			`${local_ip}/settings/cloud/?enabled=1`,
			'get',
			{},
			20000,
			true,
		);
	}

	if (!cloud_res.isok) {
		toast.open({
			type: 'danger',
			title: $format('process_cloud_err_toast', {
				default: 'Failed to enable device cloud.',
			}),
		});
		associating_devices.remove(deviceId);
		return;
	}

	assoc_list[deviceId] = device;
	let res: CloudApiResponse = await postReq(
		'device/badd',
		{ devices: JSON.stringify(assoc_list) },
		20000,
	);

	if (res.isok) {
		associating_devices.remove(deviceId);
	} else if (Object.keys(res.data?.errors).length > 0) {
		toast.open({
			type: 'danger',
			title: $format('failed_to_add', {
				default: 'Failed to add the device, please try again.',
			}),
		});
		associating_devices.remove(deviceId);
		return;
	}
};
